import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "auto",
  height: "auto",
  fill: "none",
  viewBox: "0 0 400 480"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h400v480H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M0 0h400v480H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#E7E7E7",
      d: "m363.177 120.081-62.726 25.208L165 480h235V0h-40.454L252.221 120.406z"
    }, null, -1)
  ])))
}
export default { render: render }